import {AgGridReact} from "ag-grid-react";
import {Button, Modal} from "semantic-ui-react";
import {TagModal} from "./TagModal";
import {useEffect, useState} from "react";
import {useAppDispatch} from "../../app/hooks";
import {DeleteCounter, DeleteDpiValue, DeleteInvent, DeleteLabelSize, DeleteTag, RemoveEmployee} from "./TablesActions";
import {DpiModal} from "./DpiModal";
import {LabelSizeModal} from "./LabelSizeModal";
import {useSelector} from "react-redux";
import {RootState} from "../../app/store";
import {EmployeeModal} from "./EmployeeModal";
import {InventModal} from "./InventModal";
import {IInventTable} from "../../interfaces/InventTable";
import {CounterModal} from "./CounterModal";
import {ICounterTable} from "../../interfaces/CounterTable";
import { useTranslation } from "react-i18next";
import { showErrorToast } from "../../utils/showToast";
import { ReprintTemplate } from "../Header/ExportActions";
import { ChangeRoleModal } from "./ChangeRoleModal";
interface Props {
  gridName: string;
  columns: any;
  rowData: any;
}

export const TabTable = ({gridName, columns, rowData}: Props) => {
  const dispatch = useAppDispatch();
  const [openTagModal, setOpenTagModal] = useState({open: false, row: {}, updateRow: false});
  const [openDpiModal, setOpenDpiModal] = useState(false);
  const [openEmployeeModal, setOpenEmployeeModal] = useState(false);
  const [openLabelSizeModal, setOpenLabelSizeModal] = useState({open: false, row: {}, updateRow: false});
  const [openInventModal, setOpenInventModal] = useState({open: false, row: {}, updateRow: false});
  const [openCounterModal, setOpenCounterModal] = useState({open: false, row: {}, updateRow: false});
  const [openChangeRoleModal, setOpenChangeRoleModal] = useState({open: false, user: {}});
  const [selectedRow, setSelectedRow] = useState<any>(null);
  const [openDeleteEmployeeModal, setOpenDeleteEmployeeModal] = useState(false);
  const {role, companyId} = useSelector((state: RootState) => state.auth);
  const {t} = useTranslation();
  const handleDelete = () => {
    setOpenDeleteEmployeeModal(true);
  };

  const handleConfirmDelete = () => {
    dispatch(RemoveEmployee(selectedRow.email, companyId));
    setOpenDeleteEmployeeModal(false);
  };

  const showChangeRoleModal = () => {
    if(selectedRow && selectedRow.roleId !== 'super_admin'){
      setOpenChangeRoleModal({open: true, user: selectedRow});
    } else {
      showErrorToast(t("error"), t("change_super_admin_err"));
    }
  }

  const handleAddNewRecord = () => {
    switch (gridName) {
      case "tags":
        setOpenTagModal({open: true, row: {}, updateRow: false});
        break;
      case "dpi":
        setOpenDpiModal(true);
        break;
      case "labelSize":
        setOpenLabelSizeModal({open: true, row: {}, updateRow: false});
        break;
      case "employees":
        setOpenEmployeeModal(true);
        break;
      case "inventtable":
        setOpenInventModal({open: true, row: {}, updateRow: false});
        break;
      case "countertable":
        setOpenCounterModal({open: true, row: {}, updateRow: false});
        break;
      default:
        break;
    }
  };
  const onRowDoubleClicked = (event: any) => {
    if(event.data && event.data.companyid === 0 && role !== 'super_admin'){
      showErrorToast(t("disabled_row"), t("disabled_row_msg"));
      return;
    } 
    switch (gridName) {
      case "tags":
        //setSelectedRow(event.data);
        setOpenTagModal({open: true, row: event.data, updateRow: true});
        break;
      case "labelSize":
        setOpenLabelSizeModal({open: true, row: event.data, updateRow: true});
        break;
      case "inventtable":
        setOpenInventModal({open: true, row: event.data, updateRow: true});
        break;
      case "countertable":
        setOpenCounterModal({open: true, row: event.data, updateRow: true});
        break;
      case "printtable":
        handleReprint(event.data.id);
        break;
      case "employees":
        showChangeRoleModal();
        break;  
      default:
        break;
    }
  };

  const handleDeleteSelected = () => {
    if (!selectedRow) return;
    if(selectedRow && selectedRow.companyid === 0 && role !== 'super_admin'){
      showErrorToast(t("disabled_row"), t("disabled_row_msg"));
      return;
    } 
    switch (gridName) {
      case "tags":
        dispatch(DeleteTag(selectedRow.id, companyId));
        break;
      case "dpi":
        dispatch(DeleteDpiValue(selectedRow.dpi, companyId));
        break;
      case "labelSize":
        dispatch(DeleteLabelSize(selectedRow.id, companyId));
        break;
      case "employees":
        handleDelete();
        break;
      case "inventtable":
        dispatch(DeleteInvent(selectedRow.itemId, companyId));
        break;
      case "countertable":
        dispatch(DeleteCounter(selectedRow.name, companyId));
        break;
      default:
        break;
    }
  };

  const handleReprint = (id: number) => {
    dispatch(ReprintTemplate(id));
  };

  const onSelectionChanged = (event: any) => {
    setSelectedRow(event.api.getSelectedRows()[0]);
  };

  return (
    <>
      <ChangeRoleModal open={openChangeRoleModal.open} onClose={() => setOpenChangeRoleModal({open:false, user:{}})} user={selectedRow} />
      <DeleteEmployeeModal open={openDeleteEmployeeModal} onHide={() => setOpenDeleteEmployeeModal(false)} handleConfirmDelete={handleConfirmDelete} email={selectedRow?.email} t={t} />
      <TagModal open={openTagModal.open} row={openTagModal.row} updateRow={openTagModal.updateRow} onClose={() => setOpenTagModal({open: false, row: {}, updateRow: false})} />
      <DpiModal open={openDpiModal} onClose={() => setOpenDpiModal(false)} />
      <CounterModal
        open={openCounterModal.open}
        row={openCounterModal.row as ICounterTable}
        updateRow={openCounterModal.updateRow}
        onClose={() => setOpenCounterModal({open: false, row: {}, updateRow: false})}
      />
      <InventModal
        open={openInventModal.open}
        row={openInventModal.row as IInventTable}
        updateRow={openInventModal.updateRow}
        onClose={() => setOpenInventModal({open: false, row: {}, updateRow: false})}
      />
      <LabelSizeModal
        open={openLabelSizeModal.open}
        row={openLabelSizeModal.row}
        updateRow={openLabelSizeModal.updateRow}
        onClose={() => setOpenLabelSizeModal({open: false, row: {}, updateRow: false})}
      />
      {(role === "super_admin" || role === "admin") && <EmployeeModal open={openEmployeeModal} onClose={() => setOpenEmployeeModal(false)} />}
      {gridName === "employees" ? (
        (role === "super_admin" || role === "admin") && (
          <div style={{display: "flex"}}>
            <div style={{marginLeft: "auto"}}>
              <Button positive icon="plus" basic size="small" compact content={t("add_new_btn")} onClick={handleAddNewRecord} />
              <Button negative icon="trash" basic size="small" compact content={t("delete_btn")} onClick={handleDeleteSelected} />
            </div>
          </div>
        )
      ) : gridName !== "printtable" ? (
        <div style={{display: "flex"}}>
          <div style={{marginLeft: "auto"}}>
            <Button positive icon="plus" basic size="small" compact content={t("add_new_btn")} onClick={handleAddNewRecord} />
            <Button negative icon="trash" basic size="small" compact content={t("delete_btn")} onClick={handleDeleteSelected} />
          </div>
        </div>
      ) : (
        <></>
      )}

      <div className="ag-theme-alpine" style={{height: gridName !== "printtable" ? "97.6%" : "101%", textAlign: "left", width: "100%"}}>
        <AgGridReact
          rowSelection="single"
          defaultColDef={{resizable: true, sortable: true, filter: true}}
          maintainColumnOrder
          enableCellTextSelection
          columnDefs={columns}
          rowData={rowData}
          onSelectionChanged={onSelectionChanged}
          onRowDoubleClicked={onRowDoubleClicked}
          suppressHorizontalScroll={gridName !== "inventtable"}
          suppressScrollOnNewData = {true}
          getRowClass={(params) => {
            return params.data.companyid === 0 && role !== 'super_admin' && gridName !== 'countertable' && gridName !== 'inventtable' ? 'disabled-row' : '';
          }}
        ></AgGridReact>
      </div>
    </>
  );
};

interface IProps {
  open: boolean;
  onHide: () => void;
  handleConfirmDelete: () => void;
  email?: string | null;
  t: any;
}
const DeleteEmployeeModal = ({open, onHide, handleConfirmDelete, email, t}: IProps) => {
  useEffect(() => {
    if (!email) {
      onHide();
    }
  }, [email, onHide]);
  return (
    <Modal open={open} onClose={onHide} size="small">
      <Modal.Header>{t("delete_user_modal")} {email} ? </Modal.Header>
      <Modal.Actions>
        <Button onClick={onHide}>{t("cancel_btn")}</Button>
        <Button onClick={handleConfirmDelete} negative>
        {t("proceed_btn")}
        </Button>
      </Modal.Actions>
    </Modal>
  );
};
